import React = require('react');
import { LoginUrlsWrapper } from '~src/app/spaces/Login/LoginUrls';
import { ResetPasswordProviderProps } from '~src/app/spaces/Login/ResetPasswordProvider';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { ResetPasswordWithTokenForm } from './ResetPasswordWithTokenForm';
import { ResetPasswordWithUsernameForm } from './ResetPasswordWithUsernameForm';
import { AuthenticationService } from '../services/AuthenticationService';
import { IValidatePasswordResetTokenResult } from '~src/ts/ServerApi/requests/ValidatePasswordResetTokenRequest';
import { SignInLogo } from '~src/app/spaces/Login/SignInLogo';

enum PasswordResetModes {
  TOKEN, OLD_PASSWORD
}

export function ResetPasswordActionPage(props: ResetPasswordProviderProps) {
  const [mode, setMode] = React.useState(null as PasswordResetModes);

  function validatePasswordResetToken(): void {
    AuthenticationService.validatePasswordResetToken(props.token)
      .then((validateTokenResult: IValidatePasswordResetTokenResult) => {
        return;
      }, (errorCode: number) => {
        LoginUrlsWrapper.navigateToSignIn({
          error: errorCode
        });
      });
  }

  function navigateToSignInPageIfFeatureFlagNotSet(): void {
    if (mode === PasswordResetModes.TOKEN && !ServerSettingsUnauthenticated.isPasswordResetEnabled()) {
      LoginUrlsWrapper.navigateToSignIn({});
    } else if (mode === PasswordResetModes.OLD_PASSWORD && !FeatureFlags.localAuthPasswordExpirationEnabled) {
      LoginUrlsWrapper.navigateToSignIn({});
    }
  }

  function displayResetPasswordForm() {
    if (mode === PasswordResetModes.TOKEN) {
      return <ResetPasswordWithTokenForm
        token={props.token}
      />;
    } else {
      return <ResetPasswordWithUsernameForm
        username={props.username} />;
    }
  }

  React.useEffect(() => {
    setMode(props.token ? PasswordResetModes.TOKEN : PasswordResetModes.OLD_PASSWORD);

    navigateToSignInPageIfFeatureFlagNotSet();
    if (props.token) {
      validatePasswordResetToken();
    }
  }, [props.token]);

  return (
    <div className='tb-login'>
      <span className='tb-login-form-container'>
        <SignInLogo />
        {displayResetPasswordForm()}
      </span>
    </div>);
}
